
import { Menu } from '@/types/menu';

export function processMenuData(rawMenuData: any): Menu {
  console.log('🔄 Processing raw menu data:', rawMenuData);
  
  // Ensure all URLs are properly formatted and not null
  const cleanUrl = (url: any): string | undefined => {
    if (!url || url === 'null' || url === 'undefined' || typeof url !== 'string') {
      return undefined;
    }
    // Force HTTPS
    return url.replace('http://', 'https://');
  };

  const processedMenu: Menu = {
    id: rawMenuData.id,
    name: rawMenuData.name || '',
    description: rawMenuData.description,
    slug: rawMenuData.slug,
    type: rawMenuData.type || 'restaurant',
    theme: rawMenuData.theme || 'default',
    active: rawMenuData.active !== false,
    primary_color: rawMenuData.primary_color || '#8B5CF6',
    font_family: rawMenuData.font_family || 'Inter, sans-serif',
    restaurant_id: rawMenuData.restaurant_id,
    reservations_enabled: rawMenuData.reservations_enabled,
    
    // Clean and process URLs
    banner_url: cleanUrl(rawMenuData.banner_url),
    cover_url: cleanUrl(rawMenuData.cover_url),
    logo_url: cleanUrl(rawMenuData.logo_url),
    
    // Process custom_css object
    custom_css: rawMenuData.custom_css ? {
      ...rawMenuData.custom_css,
      bannerUrl: cleanUrl(rawMenuData.custom_css.bannerUrl),
      coverUrl: cleanUrl(rawMenuData.custom_css.coverUrl),
      logoUrl: cleanUrl(rawMenuData.custom_css.logoUrl),
    } : null,
    
    categories: rawMenuData.categories,
    category_order: rawMenuData.category_order,
    created_at: rawMenuData.created_at,
    updated_at: rawMenuData.updated_at,
  };

  console.log('✅ Processed menu data:', {
    id: processedMenu.id,
    name: processedMenu.name,
    banner_url: processedMenu.banner_url,
    cover_url: processedMenu.cover_url,
    logo_url: processedMenu.logo_url,
    custom_css_bannerUrl: processedMenu.custom_css?.bannerUrl,
    custom_css_coverUrl: processedMenu.custom_css?.coverUrl,
  });

  return processedMenu;
}

export function checkHappyHour(schedule: any): boolean {
  if (!schedule || !schedule.enabled) return false;
  
  const now = new Date();
  const currentTime = now.getHours() * 60 + now.getMinutes();
  const currentDay = now.getDay();
  
  const daySchedule = schedule.days?.[currentDay];
  if (!daySchedule || !daySchedule.enabled) return false;
  
  const startTime = daySchedule.start ? 
    parseInt(daySchedule.start.split(':')[0]) * 60 + parseInt(daySchedule.start.split(':')[1]) : 0;
  const endTime = daySchedule.end ? 
    parseInt(daySchedule.end.split(':')[0]) * 60 + parseInt(daySchedule.end.split(':')[1]) : 0;
  
  return currentTime >= startTime && currentTime <= endTime;
}
